import { render, staticRenderFns } from "./PPVFreqPeakToolBl.vue?vue&type=template&id=48507a9c&scoped=true&"
import script from "./PPVFreqPeakToolBl.vue?vue&type=script&lang=js&"
export * from "./PPVFreqPeakToolBl.vue?vue&type=script&lang=js&"
import style0 from "./PPVFreqPeakToolBl.vue?vue&type=style&index=0&id=48507a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48507a9c",
  null
  
)

/* custom blocks */
import block0 from "./PPVFreqPeakToolBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports